/*
    Merrid Controls. Wszelkie prawa zastrzeżone.
    Plik zawiera kody Źródłowe będące własnością firmy Merrid Controls.
    Nie wolno ich rozpowszechniać w całości lub fragmentach bez wyraźnej zgody właściciela.
*/


import ENV from "react-dotenv";


import API_STATE_TYPE , {
    API_ACTION_TYPE,
    CHANGE_API_REQUEST_TOKEN
} from "@Actions/Api";


import AUTHORIZATION_TOKEN_INTERFACE from "@Reducers/Api/RequestToken";


const {APP_NAME} = ENV || {};
const APP_REST_API_TOKEN_KEY = (APP_NAME || "") + "_APP_REQUEST_TOKEN";


const storedApiToken: string | null = localStorage.getItem(APP_REST_API_TOKEN_KEY);
const storedApiTokenObject: AUTHORIZATION_TOKEN_INTERFACE = !!storedApiToken ? JSON.parse(storedApiToken) : null;

let storedApiTokenLeftTime: number = 0;

if (storedApiTokenObject) {
    storedApiTokenLeftTime = ((new Date()).getTime() - +storedApiTokenObject.tokenCreateDate) / 1000;
    if (storedApiTokenLeftTime > 300) storedApiTokenLeftTime = 0;
    storedApiTokenObject.tokenValidTime = (storedApiTokenObject.tokenValidTime || 0) - storedApiTokenLeftTime;
    if (storedApiTokenLeftTime === 0) localStorage.removeItem(APP_REST_API_TOKEN_KEY);
}


const ApiState: API_STATE_TYPE = {
    requestToken: storedApiTokenObject
};


export const ApiReducer = (
    state = ApiState,
    action: API_ACTION_TYPE
): API_STATE_TYPE => {

    switch (action.type) {

        case CHANGE_API_REQUEST_TOKEN:
            const newToken: AUTHORIZATION_TOKEN_INTERFACE = Object.assign({}, action.token);
            localStorage.setItem(APP_REST_API_TOKEN_KEY, JSON.stringify(newToken));
            return {...state, requestToken: newToken || null};

        default:
            return state;

    }

};


export default ApiReducer;
